import React, {useMemo, useRef, useState} from 'react';
import styles from './Toolbar.module.scss'
import {ToolbarPropsInterface} from "@/views/Admin/Events/Event/Promocodes/Toolbar/Toolbar.props.interface";
import {Button, Input, Select, useToast} from "uikit";
import ChevronIcon from "@/assets/images/icons/16/arrow.svg";
import TrashIcon from "uikit/src/assets/icons/16/trash.svg";
import Empty from "@/views/Admin/Events/Event/Promocodes/Empty/Empty";
import {useQueryRouter} from "@/hooks/useQueryRouter/useQueryRouter";
import Export from "@/views/Admin/Events/Event/Promocodes/Export/Export";
import {PromocodesService} from "@/services/PromocodesService/PromocodesService";
import {API} from "@/api/API";
import axios from "axios";
import {useLocation} from "react-router-dom";

const Toolbar = ({data, onChange, onRemove}: ToolbarPropsInterface) => {
    const [active, setActive] = useState<boolean>(false);
    const {isLoading} = data
    const {query, reset} = useQueryRouter();
    const exportActionRef = useRef<(payload: Record<string, string>) => void>(console.log);

    const isFilterActive = Object.values(query.filter ?? {}).some(v => v !== '' && v !== null && v !== undefined);

    const {search} = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const tabs = data.tabs
    const content = tabs.includes(params.get('content') as string) ? params.get('content') : 'promocodes';
    const current = data[content]
    const isEmpty = !current.data.length && !isFilterActive && !isLoading;
    const isEmptyGlobal = !data.promocodes.data.length && !data.groups.data.length && !isFilterActive && !data.isLoading && !current.isLoading;
    const isActive = isEmpty || !current.data.some(p => p.isActive)
    const toast = useToast()
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);
        formData.append('send_notifications', 'true');
        const response = await PromocodesService.Excel.Import(formData);

        try {
            const {data} = response
            const err = data?.errors?.[0]?.detail || data?.message;
            if (err && !data.redirect) toast({type: 'danger', message: err})
            else window.location.href = data.redirect
        } catch (err: any) {
            const status = err?.response?.status;
            const detail = err.response?.data?.errors?.[0]?.detail;
            const message = err.response?.data?.message;
            toast({type: 'danger', message: detail || message || `Ошибка сервера ${status ?? ''}`});
        }
    };

    const handleExportPromocodes = () => {
        exportActionRef.current = async (payload) => {
            try {
                const mapBool = (o: any) => Object.fromEntries(Object.entries(o).map(([k, v]) => [k, v === 'true' ? true : v === 'false' ? false : v]));
                return await PromocodesService.Excel.Export({
                    ...mapBool(payload),
                    ...mapBool(query.filter || {}),
                    ...(data.promocodes.data.some(p => p.isActive) && {promocodeIds: data.promocodes.data.filter(p => p.isActive).map(p => p.id)})
                });
            } catch (e: any) {
                return e;
            }
        };
        setActive(true);
    };

    const handleImportPromocodes = () => {
        fileInputRef.current?.click();
    }

    const handleTemplateDownload = async () => {
        try {
            const {data: blob, headers} = await axios({
                method: API.templatePromocodesToExcel.method,
                url: API.templatePromocodesToExcel.path,
                responseType: 'blob', data: {},
            });
            const filename = headers['content-disposition']?.match(/filename="?([^";]+)"?/)?.[1] || 'template.xlsx';

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (e) {
            console.error('Ошибка скачивания:', e);
        }
    };

    const handleRemoveSelected = async () => {
        await onRemove(current.data.filter(p => p.isActive))
    }

    const handleSubmit = (payload: Record<string, string>) => {
        return exportActionRef.current?.(payload);
    };

    const handleCancel = () => {
        setActive(false);
    };

    return (
        <div className={[
            styles.container,
            isEmptyGlobal && styles.isEmptyGlobal,
            !isEmptyGlobal && !data[content].data.length && styles.isCenter
        ].filter(Boolean).join(' ')}>
            <Export
                data={data}
                onSubmit={active ? handleSubmit : undefined}
                onCancel={handleCancel}
            />
            <Empty
                data={data}
                onChange={onChange}
            />
            {(!isEmpty || isEmptyGlobal) && <div className={styles.select}>
                <Input
                    inputRef={fileInputRef}
                    type="file"
                    accept=".csv,.xls,.xlsx,.ods"
                    onChange={handleFileChange}
                    style={{display: 'none'}}
                    value={null}
                />
                <Select
                    direction={['bottom', isEmptyGlobal ? 'center' : 'left']}
                    disabled={isLoading}
                    onChange={() => null}
                    data={[
                        <div
                            className={styles.item}
                            onClick={handleExportPromocodes}>
                            Скачать промокоды <small>Файл Excel будет отправлен на почту</small>
                        </div>,
                        <div
                            className={styles.item}
                            onClick={handleImportPromocodes}>
                            Загрузить промокоды <small>Добавить или обновить промокоды</small>
                        </div>,
                        <div
                            className={styles.item}
                            onClick={handleTemplateDownload}>
                            Скачать шаблон файла <small>Образец для загрузки</small>
                        </div>
                    ]}>
                    <Button
                        size={'small'}
                        type={'secondary'}
                        htmlType={'button'}
                        theme={'default'}>
                        Загрузить файл
                        <ChevronIcon/>
                    </Button>
                </Select>
            </div>}
            {!isEmpty && <Button
                onClick={handleRemoveSelected}
                type={'tertiary'}
                theme={'default'}
                disabled={isLoading || isActive || isEmpty}
                className={styles.button}>
                <TrashIcon/>
            </Button>}
        </div>
    );
};

export default Toolbar;
